import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71ffef90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "d-flex align-items-center gap-4" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "card-body py-4" }
const _hoisted_6 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Party ID", -1))
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = ["onClick"]

import { onMounted, ref, computed } from "vue";
import TableFooter from "@/components/TableFooter.vue";
import UserDetails from "../../../components/UserDetails.vue";
import TimeShow from "@/components/TimeShow.vue";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
// import SearchFilter from "@/components/SearchFilter.vue";
import UserService from "../services/UserService";
import { Search } from "@element-plus/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersIndex',
  setup(__props) {

const userShow = ref<InstanceType<typeof UserDetails>>();
const users = ref(Array<any>());
const isLoading = ref(true);
// const searchTrigger = ref(false);

const criteria = ref<any>({
  page: 1,
  size: 20,
  total: 0,
  showInactive: false,
});

onMounted(() => {
  fetchData(1);
});

const filteredUsers = computed(() => {
  return users.value;
});

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const results = criteria.value.showInactive
      ? await UserService.getUsers(criteria.value)
      : await UserService.getActiveUsers(criteria.value);

    // 确保 criteria 对象始终包含分页信息
    if (results && results.criteria) {
      criteria.value = {
        ...criteria.value,
        ...results.criteria,
        // 确保这些属性始终存在
        page: results.criteria.page || criteria.value.page,
        size: results.criteria.size || criteria.value.size,
        total: results.criteria.total || 0,
      };
    } else {
      // 如果API没有返回criteria，保持现有的分页信息
      console.warn("API did not return criteria object");
      criteria.value.total = results?.data?.length || 0;
    }

    users.value = results?.data || [];
  } catch (e) {
    console.error("API Error:", e);
    // 确保即使在错误情况下也有基本的分页信息
    criteria.value.total = 0;
    users.value = [];
  }
  isLoading.value = false;
};

const onShowInactiveChange = () => {
  // 重置到第一页，因为不同模式下的数据可能不同
  criteria.value.page = 1;
  fetchData(1);
};

const reset = async () => {
  criteria.value = {
    page: 1,
    size: 20,
    total: 0,
    showInactive: false,
    searchText: "", // 确保searchText也被重置
  };
  await fetchData(1);
};

const showDetail = async (partyId: number) => {
  userShow.value?.show(partyId);
};

const getUserName = (item: any) => {
  if (!item.nativeName || item.nativeName === "" || item.nativeName === " ") {
    if (
      !item.displayName ||
      item.displayName === "" ||
      item.displayName === " "
    ) {
      if (
        !item.firstName ||
        !item.lastName ||
        item.firstName === "" ||
        item.lastName === "" ||
        item.firstName === " " ||
        item.lastName === " "
      ) {
        return "No Name";
      } else {
        return item.firstName + " " + item.lastName;
      }
    } else {
      return item.displayName;
    }
  } else {
    return item.nativeName;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_UserInfo = _resolveComponent("UserInfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("title.user")), 1),
          _createVNode(_component_el_input, {
            modelValue: criteria.value.searchText,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.searchText) = $event)),
            style: {"max-width":"600px"},
            placeholder: _ctx.$t('tip.searchKeyWords'),
            clearable: "",
            class: "w-300px",
            disabled: isLoading.value,
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _unref(Search),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchData(1))),
                disabled: isLoading.value
              }, null, 8, ["icon", "disabled"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "disabled"]),
          _createVNode(_component_el_button, {
            disabled: isLoading.value,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (reset()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_switch, {
            modelValue: criteria.value.showInactive,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((criteria.value.showInactive) = $event)),
            "active-text": _ctx.$t('action.showInactive'),
            "inactive-text": _ctx.$t('action.hideInactive'),
            disabled: isLoading.value,
            onChange: onShowInactiveChange,
            class: "ms-2"
          }, null, 8, ["modelValue", "active-text", "inactive-text", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.site")), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.emailConfirmed")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.phoneNum")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.country")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.language")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                _createVNode(LoadingRing)
              ]))
            : (!isLoading.value && users.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  _createVNode(NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUsers.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass([{ 'row-inactive': item.status !== 0 }])
                    }, [
                      _createElementVNode("th", null, _toDisplayString(item.partyId) + " (" + _toDisplayString(item.id) + ") ", 1),
                      _createElementVNode("td", _hoisted_13, [
                        _createVNode(_component_UserInfo, {
                          url: "#",
                          avatar: item.avatar,
                          title: getUserName(item),
                          sub: item.email,
                          name: getUserName(item),
                          user: item,
                          class: "me-2"
                        }, null, 8, ["avatar", "title", "sub", "name", "user"])
                      ]),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("type.siteType." + item.siteId)), 1),
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("i", {
                          class: "fa-solid fa-circle-check fa-lg",
                          style: _normalizeStyle(item.emailConfirmed ? 'color: #5cb85c' : 'color: #gray')
                        }, null, 4)
                      ]),
                      _createElementVNode("td", null, "+" + _toDisplayString(item.ccc) + " " + _toDisplayString(item.phoneNumber), 1),
                      _createElementVNode("td", null, _toDisplayString(item.countryCode), 1),
                      _createElementVNode("td", null, _toDisplayString(item.language), 1),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.updatedOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "btn btn-light btn-success btn-sm me-3",
                          onClick: ($event: any) => (showDetail(item.partyId)),
                          disabled: false
                        }, _toDisplayString(_ctx.$t("title.details")), 9, _hoisted_15)
                      ])
                    ], 2))
                  }), 128))
                ]))
        ]),
        _createVNode(TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(UserDetails, {
      ref_key: "userShow",
      ref: userShow
    }, null, 512)
  ], 64))
}
}

})